import cx from 'classnames'
import TextareaAutosize from 'react-textarea-autosize'
import { FormInput } from '../form'
import { Caption } from '../textNodes'

export const Row = ({ children }) => (
  <div className="burosferaVacancyForm-row">
    { children }
  </div>
)

export const Label = ({ text, name }) => (
  <div className={ `formLabel burosferaVacancyForm-${name}` }>
    <label htmlFor={ name } dangerouslySetInnerHTML={{ __html: text }} />
  </div>
)

export const Input = ({ name, value, onInput, required = true }) => {
  const type = /email/i.test(name) ? 'email' : 'text'

  return (
    <div className="formInput">
      <FormInput
        className="is__fullWidth"
        id={ name }
        name={ name }
        value={ value }
        onInput={ onInput }
        type={ type }
        required={ required } />
    </div>
  )
}

export const JobFormatSwitcher = ({ value, onRemoteClick, onOfficeClick }) => (
  <div className="formSwitcher">
    <div className={ cx('formSwitcher-item', { is__active: value === 'remote' }) } onClick={ onRemoteClick }>
      <span>Можно удалённо</span>
    </div>
    <div className={ cx('formSwitcher-item', { is__active: value === 'office' }) } onClick={ onOfficeClick }>
      <span>Только офис</span>
    </div>
  </div>
)

export const JobDescriptionTextarea = ({ uid, value, onInput }) => (
  <div className="formTextarea-wrapper media">
    <TextareaAutosize
      key={ [uid, 'jobDescription'].join(':') } // HACK: otherwise textarea won't reset as it's not manageable component
      className="formTextarea"
      id="jobDescription"
      name="jobDescription"
      onInput={ onInput }>{ value }</TextareaAutosize>
  </div>
)

export const DraftCaption = () => (<Caption className="burosferaVacancyForm-draftCaption">✓ Черновик сохранён</Caption>)
